export default function AboutSection() {
  const pillars = [
    {
      icon: "ri-global-line",
      title: "Unbiased Global Reach",
      desc: "We leverage a neutral, far-reaching network of manufacturers and partners across Europe, China, and India to put the world's best resources to work for our clients.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Regulatory Authority",
      desc: "We ensure absolute compliance with the most stringent mandates in the US, Europe, and Canada (FDA, EMA, and Health Canada).",
    },
    {
      icon: "ri-database-2-line",
      title: "Data-Driven Transparency",
      desc: 'Every mandate is backed by a "digital thread" of full documentation and end-to-end traceability, ensuring audit-readiness in regulated and food-grade markets.',
    },
    {
      icon: "ri-settings-3-line",
      title: "Scalable Solutions",
      desc: "From off-the-shelf procurement to turnkey, large-scale custom production, we deliver realistic, viable options under strict confidentiality.",
    },
    {
      icon: "ri-translate-2",
      title: "Bilingual — FR & EN",
      desc: "We serve our clients fully in both French and English, ensuring seamless communication across Canada, Europe, and all international markets.",
    },
  ];

  return (
    <section className="w-full bg-white py-20 px-6 md:px-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-start">
        {/* Left */}
        <div className="lg:w-2/5">
          <span className="text-emerald-600 text-xs font-bold uppercase tracking-widest">
            Who We Are
          </span>
          <h2
            className="text-4xl md:text-5xl font-extrabold text-stone-800 mt-4 leading-tight"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Global Sourcing,
            <br />
            <span className="text-emerald-600">Our Expertise</span>
          </h2>
          <div className="w-16 h-1 bg-emerald-600 mt-6 mb-8 rounded-full" />
          <p
            className="text-lg font-semibold text-stone-700 leading-snug"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Strategic Sourcing. Global Compliance. Technical Precision.
          </p>
        </div>

        {/* Right */}
        <div className="lg:w-3/5 flex flex-col gap-6 text-gray-600 text-base leading-relaxed">
          <p>
            In an era of escalating trade complexity, fragmented data, and rigorous regulatory scrutiny, the
            procurement function has evolved from a back-office activity into a pivotal driver of the bottom
            line. At <strong className="text-emerald-700">MAX-Sourcing</strong>, by partnering with your
            internal teams (Purchasing, QA, Production) we bridge the gap between global supply chain
            pressures and operational excellence.
          </p>
          <p>
            We specialize in identifying, qualifying, and managing proven, collaborative sources for
            high-quality products, raw materials, and specialized development services. Our expertise spans
            the full sourcing lifecycle—from spend consolidation and cross-border benchmarking to expert
            contract negotiation and the drafting of Quality Agreements (QAs).
          </p>

          <div className="mt-2">
            <p className="text-stone-800 font-semibold text-sm uppercase tracking-widest mb-5">
              Why Global Leaders Partner with MAX-Sourcing
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
              {pillars.map((p) => (
                <div
                  key={p.title}
                  className="flex gap-4 items-start bg-stone-50 rounded-lg p-4 border border-stone-100"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-md bg-emerald-50 text-emerald-600 shrink-0">
                    <i className={`${p.icon} text-lg`} />
                  </div>
                  <div>
                    <p className="text-stone-800 font-semibold text-sm mb-1">{p.title}</p>
                    <p className="text-gray-500 text-sm leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <p className="text-stone-700 italic border-l-4 border-emerald-500 pl-5 mt-2">
            At <strong className="text-emerald-700 not-italic">MAX-Sourcing</strong>, we don&apos;t just find
            suppliers; we build the resilient, high-value partner relationships that drive modern business
            success.
          </p>
        </div>
      </div>
    </section>
  );
}
